<template>
    <vs-alert v-if="!isClosed" :class="{'con-vs-alert--closing': isTransitionClose}" :color="color">
        <span class="con-vs-alert__icon" v-if="['primary', 'warning', 'secondary', 'info'].includes(color)">
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.75 9C0.75 4.425 4.425 0.75 9 0.75C13.575 0.75 17.25 4.425 17.25 9C17.25 13.575 13.575 17.25 9 17.25C4.425 17.25 0.75 13.575 0.75 9ZM2.25 9C2.25 12.75 5.25 15.75 9 15.75C12.75 15.75 15.75 12.75 15.75 9C15.75 5.25 12.75 2.25 9 2.25C5.25 2.25 2.25 5.25 2.25 9ZM9.75 9V12C9.75 12.45 9.45 12.75 9 12.75C8.55 12.75 8.25 12.45 8.25 12V9C8.25 8.55 8.55 8.25 9 8.25C9.45 8.25 9.75 8.55 9.75 9ZM9.75 6C9.75 5.775 9.675 5.625 9.525 5.475C9.375 5.325 9.075 5.25 8.85 5.25C8.80687 5.29313 8.78854 5.31146 8.76649 5.31924C8.7502 5.325 8.73187 5.325 8.7 5.325C8.6625 5.325 8.64375 5.34375 8.625 5.3625C8.60625 5.38125 8.5875 5.4 8.55 5.4L8.475 5.475C8.325 5.625 8.25 5.775 8.25 6C8.25 6.225 8.325 6.375 8.475 6.525C8.475 6.525 8.475 6.6 8.55 6.6C8.5875 6.6 8.60625 6.61875 8.625 6.6375C8.64375 6.65625 8.6625 6.675 8.7 6.675C8.74313 6.71813 8.76146 6.73646 8.78351 6.74424C8.7998 6.75 8.81813 6.75 8.85 6.75H9C9.225 6.75 9.375 6.675 9.525 6.525C9.675 6.375 9.75 6.225 9.75 6Z"
                    :fill="colors[color]"
                />
            </svg>
        </span>
        <span class="con-vs-alert__icon" v-else-if="['success'].includes(color)">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 9V8.325C17.25 7.875 16.95 7.575 16.5 7.575C16.05 7.575 15.75 7.875 15.75 8.325V9C15.75 12.75 12.75 15.75 9 15.75C5.25 15.75 2.25 12.75 2.25 9C2.25 5.25 5.25 2.25 9 2.25C9.975 2.25 10.875 2.475 11.775 2.85C12.15 3 12.6 2.85 12.75 2.475C12.9 2.1 12.75 1.65 12.375 1.5C11.325 0.975 10.125 0.75 9 0.75C4.425 0.75 0.75 4.425 0.75 9C0.75 13.575 4.425 17.25 9 17.25C13.575 17.25 17.25 13.575 17.25 9ZM16.725 1.725C17.025 1.425 17.475 1.425 17.775 1.725C18.075 2.025 18.075 2.475 17.775 2.775L9.525 11.025C9.375 11.175 9.15 11.25 9 11.25C8.85 11.25 8.625 11.175 8.475 11.025L6.225 8.775C5.925 8.475 5.925 8.025 6.225 7.725C6.525 7.425 6.975 7.425 7.275 7.725L9 9.45L16.725 1.725Z" :fill="colors[color]"/>
            </svg>
        </span>
        <span class="con-vs-alert__icon" v-else-if="['danger'].includes(color)">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9 0.75C4.425 0.75 0.75 4.425 0.75 9C0.75 13.575 4.425 17.25 9 17.25C13.575 17.25 17.25 13.575 17.25 9C17.25 4.425 13.575 0.75 9 0.75ZM9 15.75C5.25 15.75 2.25 12.75 2.25 9C2.25 5.25 5.25 2.25 9 2.25C12.75 2.25 15.75 5.25 15.75 9C15.75 12.75 12.75 15.75 9 15.75ZM10.05 9L11.775 7.275C12.075 6.975 12.075 6.525 11.775 6.225C11.475 5.925 11.025 5.925 10.725 6.225L9 7.95L7.275 6.225C6.975 5.925 6.525 5.925 6.225 6.225C5.925 6.525 5.925 6.975 6.225 7.275L7.95 9L6.225 10.725C5.925 11.025 5.925 11.475 6.225 11.775C6.375 11.925 6.525 12 6.75 12C6.975 12 7.125 11.925 7.275 11.775L9 10.05L10.725 11.775C10.875 11.925 11.025 12 11.25 12C11.475 12 11.625 11.925 11.775 11.775C12.075 11.475 12.075 11.025 11.775 10.725L10.05 9Z" :fill="colors[color]" />
            </svg>
        </span>
        <slot></slot>

        <span v-if="closeable" @click="onClose" class="con-vs-alert__close cursor-pointer">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.46659 8.53334C9.73325 8.80001 9.73325 9.20001 9.46659 9.46668C9.33325 9.60001 9.19992 9.66668 8.99992 9.66668C8.79992 9.66668 8.66659 9.60001 8.53325 9.46668L4.99992 5.93334L1.46659 9.46668C1.33325 9.60001 1.19992 9.66668 0.999919 9.66668C0.799919 9.66668 0.666585 9.60001 0.533252 9.46668C0.266585 9.20001 0.266585 8.80001 0.533252 8.53334L4.06659 5.00001L0.533252 1.46668C0.266585 1.20001 0.266585 0.80001 0.533252 0.533344C0.799919 0.266677 1.19992 0.266677 1.46659 0.533344L4.99992 4.06668L8.53325 0.533344C8.79992 0.266677 9.19992 0.266677 9.46659 0.533344C9.73325 0.80001 9.73325 1.20001 9.46659 1.46668L5.93325 5.00001L9.46659 8.53334Z" :fill="colors[color]"/>
            </svg>
        </span>
    </vs-alert>
</template>

<script>
export default {
    name: "alert",
    props: {
        color: String,

        closeable: {
            type: Boolean,
            default: true
        },
    },

    data() {
        return {
            colors: {
                "primary": "#da2d8a",
                "success": "#28c76f",
                "danger": "#ea5455",
                "warning": "#ff9f43",
                "secondary": "#6c757d",
                "info": "#00cfe8"
            },

            isClosed: false,
            isTransitionClose: false
        };
    },

    methods: {
        onClose() {
            this.isTransitionClose = true;
            setTimeout(() => {
                this.isClosed = true
            }, 300);
        }
    },
};
</script>

<style lang="scss">
.con-vs-alert {
    border-radius: 3px;
    height: auto!important;

    transition: all 300ms ease;

    .con-vs-alert__icon {
        position: absolute;
        top: 10px;
        left: 10px;
    }

    &.con-vs-alert-info {
        background-color: rgba($color: #00cfe8, $alpha: 0.12);
        color: #00cfe8;
    }

    &.con-vs-alert-secondary {
        background-color: rgba($color: #6c757d, $alpha: 0.12);
        color: #6c757d;
    }

    &.con-vs-alert-info, &.con-vs-alert-danger, &.con-vs-alert-success, &.con-vs-alert-secondary, &.con-vs-alert-primary, &.con-vs-alert-warning {
        .vs-alert {
            padding-left: 45px !important;
        }
    }

    .vs-alert {
        padding-right: 20px;
    }

    .con-vs-alert__close {
        position: absolute;
        top: 10px;
        right: 10px;
    }

    &.con-vs-alert--closing {
        opacity: 0;
        transform: scale(0.8);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Alert/Alert.vue